import { userlogin, queryCom, addBlackList } from "@/api/attendance.js";
import pinyin from "js-pinyin";
import { Toast } from 'vant';
import { Login } from "@/api/login.js";
let _this = this;
  // 注入组件
  const mixins = {
  data(){
    return {
      citylists: [],
      lngAndLat: [],
      FirstPin: ["A", "B", "C", "D", "E", "F", "G", "H", "J", "K", "L", "M", "N", "P", "Q", "R", "S", "T", "W", "X", "Y", "Z"],
    }
  },
  methods: {
    //添加黑名单
    async addFUn(usercode){
      let params = {
        body: {
          driverusercode: usercode,
          driverphone: usercode
        }
      }
      let result = await addBlackList(params);
      console.log(result);
      this.$toast(result.message);
      return true;

    },
    //手机号脱敏
    phoneDesensitizationFun(phone){
      return phone.substring(0,3)+'******'+phone.substring(9,11)
    },
    checkPhone (e) { // 手机号校验
      if (e!= '') {
        var reg = /^1[3456789]\d{9}$/;
        if (!reg.test(e)) {
          this.$toast.fail('请输入正确手机号');
          return false
        } else {
          return true
        }
      }else{
        this.$toast.fail('请输入手机号');
        return false

      }
    },
    checkCar (e){  //车牌号校验
      if (e.length <= 8) {
        //var reg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1}$/
        var reg =  /^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z](([0-9]{5}[DF])|([DF]([A-HJ-NP-Z0-9])[0-9]{4})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳使领]))$/
        var reg0 = /^[暂]{1}[A-Z0-9]{6}$/
        if (!reg.test(e) && !reg0.test(e)) {
          this.$toast.fail('请输入正确车牌号');
          return false;
        }else{
          return true;
        }
      }
      else{
        this.$toast.fail('请输入正确车牌号');
        return false;
      }
    },
    async loginsFun(params){  //登录
      let result = await userlogin(params);
      console.log(result);
      if (result&&result.errcode == '0'){
        localStorage.setItem('usertype',result.data.usertype);
        localStorage.setItem('validstatus',result.data.validstatus);
        localStorage.setItem('usercode',result.data.usercode);
        localStorage.setItem('userid', result.data.userid);
        localStorage.setItem('phone',result.data.phone);
        localStorage.setItem('authenticationflag', result.data.authenticationflag);
        localStorage.setItem('companyname', result.data.companyname);
        localStorage.setItem('head',JSON.stringify({
          usercode: result.data.usercode,
          userid: result.data.userid
        }));
        const token = result.data.token
        const model = result.data.model
        // if (!token||!model) {
          let res =await CSDK.getPushtoken()
          console.log('getPushtoken获取token1', CSDK._getPlatform() ,res);
          let r =JSON.parse(res)
          console.log('getPushtoken获取token2', r);
          
          if (r) {
            const pushmodel = r.pushmodel || ""
            const pushtoken = r.pushtoken ||''
            console.log('getPushtoken获取token3', pushmodel,pushtoken);
            
            if (pushtoken) {
              let obj={
                "model": pushmodel,
                "token": pushtoken,
              }
              console.log(1111);
              
              Login.UpdateToken(obj)
              console.log('2222');
              
            }
          }
        // }
        // 获取当前定位的经纬度
        // let currentLocation = localStorage.getItem("currentLocation")
        //   ? JSON.parse(localStorage.getItem("currentLocation"))
        //   : [116.404, 39.915];
        // if (currentLocation&&currentLocation.length==2) {
        //   let obj = {
        //     "longitude": currentLocation[0], //经度
        //     "dimension": currentLocation[1], //维度
        //     "areaname": localStorage.getItem('addressName'), //区域名称
        //     "areacode": localStorage.getItem('addressCode'), //区域编码
        //   }
        //   Login.addPosition(obj)
        // }

        if (window.AndroidWebView) {
          const data = JSON.stringify({
            phone: result.data.phone,
            phonetype: "Android",
          });
          AndroidWebView.setPhone(data)
        }
        //人员是否注册， 1:注册，0:未注册
        if(result.data.validstatus == '0'){
          this.$router.push({
            name: 'role'
          })
        }else{
          this.$router.push({
            name: 'home'
          })
        }
      }else{
        Toast({
          message: '验证码或者其他原因验证失败请重试',
          position: 'bottom',
          duration: 2000
        })
      }
    },

    getLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.showPosition, this.showError);
      } else {
        alert("Geolocation is not supported by this browser.");
      }
    },

    showPosition(position) {
      console.log('当前定位的经纬度',position);
      
      var lat = position.coords.latitude;
      var lng = position.coords.longitude;
      //存储当前定位的经纬度
      localStorage.setItem('currentLocation',JSON.stringify([lng, lat]))
      this.reverseGeocode(lat, lng);
    },
    reverseGeocode(lat, lng) {
      var point = new BMap.Point(lng, lat);
      var gc = new BMap.Geocoder();
      let _this = this;
      gc.getLocation(point, function(rs){
        var addComp = rs.addressComponents;
        console.log('城市11:', addComp.city); // 输出城市名称
        _this.cityNew = addComp.city //目的地text
        localStorage.setItem('addressName',addComp.city);
        _this.queryComFun();
      });
    },
    showError(error) {
      switch(error.code) {
        case error.PERMISSION_DENIED:
          console.log("User denied the request for Geolocation.");
          // alert("User denied the request for Geolocation.");
          break;
        case error.POSITION_UNAVAILABLE:
          alert("Location information is unavailable.");
          break;
        case error.TIMEOUT:
          alert("The request to get user location timed out.");
          break;
        case error.UNKNOWN_ERROR:
          alert("An unknown error occurred.");
          break;
      }
    },
    // // 初始化地图
    // initMap() {
    //   if (!this.map) {
    //     this.map = new BMap.Map("mapContainer"); // 创建地图实例
    //     const point = new BMap.Point(116.404, 39.915); // 默认中心点
    //     this.map.centerAndZoom(point, 15);
    //   }
    // },

    // // 计算距离（异步）
    // async juliFun(dj1, dj2) {
    //   if (dj1.length === 0 || dj2.length === 0) {
    //     return "X"; // 如果坐标为空，返回默认值
    //   }

    //   // 初始化地图
    //   this.initMap();

    //   // 创建起点和终点标注
    //   const point1 = new BMap.Point(dj1[0], dj1[1]);
    //   const point2 = new BMap.Point(dj2[0], dj2[1]);

    //   // 返回 Promise，处理异步逻辑
    //   return new Promise((resolve, reject) => {
    //     const driving = new BMap.DrivingRoute(this.map, {
    //       renderOptions: { map: this.map, autoViewport: true },
    //       onSearchComplete: (results) => {
    //         if (driving.getStatus() === BMAP_STATUS_SUCCESS) {
    //           const distance = results.getPlan(0).getDistance(true); // 获取距离
    //           resolve(distance); // 返回距离
    //         } else {
    //           this.$toast.fail('抱歉，未找到结果');
    //           reject(new Error('未找到结果'));
    //         }
    //       },
    //       onSearchError: (error) => {
    //         this.$toast.fail('查询失败，请重试');
    //         reject(error);
    //       },
    //     });

    //     // 开始搜索路线
    //     driving.search(point1, point2);
    //   });
    // },
    // juliFun(dj1, dj2){  //计算距离
    //   console.log('dj1',dj1)
    //   console.log('dj2',dj2)
    //   if (dj1.length == 0) {
    //     return " X "
    //   }
    //   var map = new BMap.Map("mapContainer");    // 创建Map实例
    //   var point = new BMap.Point(116.404, 39.915);  // 创建点坐标
    //   map.centerAndZoom(point, 15);
    //   let point1 = new BMap.Marker(new BMap.Point(dj1[0], dj1[1]));  // 根据点击位置创建标注
    //   map.addOverlay(point1);
    //   let point2 = new BMap.Marker(new BMap.Point(dj2[0], dj2[1]));  // 根据点击位置创建标注
    //   map.addOverlay(point2);
    //   var driving = new BMap.DrivingRoute(map, {
    //     renderOptions:{map: map, autoViewport: true},
    //     onSearchComplete: function(results){
    //       setTimeout(()=>{
    //         if (driving.getStatus() == BMAP_STATUS_SUCCESS) {
    //           console.log("列表总距离（米）:", results.getPlan(0).getDistance(true));  // 输出总距离
    //           let distance = results.getPlan(0).getDistance(true);
    //           return distance;
    //         } else {
    //           this.$toast.fail('抱歉，未找到结果');
    //         }
    //       })
    //     }
    //   });
    // },
    juliFun2([lng1, lat1], [lng2, lat2]) {
      const R = 6371; // 地球半径，单位 km
      const dLat = (lat2 - lat1) * Math.PI / 180;
      const dLng = (lng2 - lng1) * Math.PI / 180;
      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1 * Math.PI / 180) *
        Math.cos(lat2 * Math.PI / 180) *
        Math.sin(dLng / 2) *
        Math.sin(dLng / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      const distance = R * c;
      return Number(distance.toFixed(2)); // 返回保留两位小数的距离
    },
async juliFun([lng1, lat1], [lng2, lat2]) {
      // 添加坐标有效性检查
      if (!lng1 || !lat1 || !lng2 || !lat2 ||
        lng1 == 0 || lat1 == 0 ||
        Math.abs(lng1) > 180 || Math.abs(lat1) > 90 ||
        Math.abs(lng2) > 180 || Math.abs(lat2) > 90) {
        console.error("无效的坐标参数:", [lng1, lat1], [lng2, lat2]);
        return Promise.reject(new Error("无效的坐标参数"));
      }
      return new Promise((resolve, reject) => {
        try {
          const map = new BMap.Map("map");
          const point1 = new BMap.Point(lng1, lat1);
          const point2 = new BMap.Point(lng2, lat2);

          const driving = new BMap.DrivingRoute(map, {
            onSearchComplete: (results) => {
              console.log("路线规划结果:", driving.getStatus());
              if (driving.getStatus() === BMAP_STATUS_SUCCESS) {
                const distanceStr = results.getPlan(0).getDistance(true);
                const distanceNum = parseFloat(distanceStr);
                resolve(distanceNum);
              } else {
                console.error("路线规划失败:", driving.getStatus());
                reject(new Error("路线规划失败"));
              }
            },
            onPolylinesSet: () => {
              // 可选：绘制路线到地图
            },
          });

          driving.search(point1, point2);
        } catch (error) {
          console.error("计算距离时发生错误:", error);
          reject(error);
        }
      });
    },
    async queryComFun(){   //获取地市列表
      console.log('fffff',localStorage.getItem('addressName'))
      let params = {
        body: {
          provincecode: ''
        }
      }
      const r = JSON.parse(localStorage.getItem('result'));
      let result;
      if (r) {
        result = r
      }else{
        result = await queryCom(params);
      }
      let list = [];
      console.log('FirstPin',this.FirstPin)
      if(result.errcode == '0'){
        localStorage.setItem('result', JSON.stringify(result))
        result.data.forEach(res=>{
          list = [...list, ...res.children];
        })

        let cityNameList = list;
        let firstName = [];
        this.FirstPin.forEach((item)=>{
          firstName[item] = [];
          console.log(localStorage.getItem('addressName'))
          cityNameList.forEach((el)=>{
            if(el.name == localStorage.getItem('addressName')){
              localStorage.setItem('addressCode',el.code)
            }
            let first = pinyin.getFullChars(el.name).substring(0,1);
            if( first == item ){
              firstName[item].push(el)
            }
          })
        })

        let newList = [];
        for(let keys in firstName){
          newList.push({
            index: keys,
            list: [...firstName[keys]]
          })
        }
        this.citylists= newList;
        localStorage.setItem('citys', JSON.stringify(newList))
        console.log('地址列表',this.citylists)
      }
    },
  },
  mounted() {

  },
  beforeDestroy() {

  },
}
export default mixins;



// WEBPACK FOOTER //
// ./src/minxins/index.js